import React from 'react'
import { useSelector } from 'react-redux'

const Nav = () => {

  const {cityData} = useSelector((state)=> state.CityWiseIplReducer)

  const handleScroll = (id) =>
  document.getElementById(id).scrollIntoView({ behavior: 'smooth' })
  
  const navLinksData = [
    { sectionId: 'glance', navHeading: 'At a Glance' },
    { sectionId: 'features', navHeading: 'Features & Benefits' },
    { sectionId: 'documents', navHeading: 'Documents required' },
    { sectionId: 'applyLoan', navHeading: 'How to Apply' },
    { sectionId: 'emiCalculator', navHeading: `EMI Calculator for ${cityData?.city}` },
    { sectionId: 'relatedLinks', navHeading: 'Related links' },
  ]

  return (
    <header className="header-nav">
      <div className="nav">
        {navLinksData?.map((link) => (
          <div
            key={link?.sectionId}
            onClick={() => handleScroll(link?.sectionId)}
          >
            {link?.navHeading}
          </div>
        ))}
      </div>
    </header>
  )
}
export default Nav